'use strict';

var GridSaveSpecialEventButtonDirective = function GridSaveSpecialEventButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-save-special-event-button.html'),
    controller: 'GridSaveSpecialEventButtonController'
  };
};
GridSaveSpecialEventButtonDirective.$inject = [];
module.exports = GridSaveSpecialEventButtonDirective;